export default __webpack_public_path__ + "d0927db.png";